import type { OptimizerQueryState } from "./query-state";
import type { PlatformType } from "./utils-v2";
import {
  SPORTSBOOK_SURFACE,
  getSportsbookSurfacePolicy,
} from "@/lib/sportsbook-preferences";

export const FANTASY_PROPS_BOOKS: PlatformType[] = [
  ...getSportsbookSurfacePolicy(SPORTSBOOK_SURFACE.OPTIMIZER_FANTASY_PROPS)
    .supportedBookIds,
];

const FANTASY_BOOK_SET = new Set<PlatformType>(FANTASY_PROPS_BOOKS);

export const DEFAULT_FANTASY_BOOK: PlatformType = "prizepicks";

export function isFantasyPropsBook(book?: string | null): book is PlatformType {
  const normalized = (book ?? "").trim().toLowerCase() as PlatformType;
  return FANTASY_BOOK_SET.has(normalized);
}

export function ensureFantasyBook(book?: string | null): PlatformType {
  const normalized = (book ?? "").toLowerCase() as PlatformType;
  return FANTASY_BOOK_SET.has(normalized) ? normalized : DEFAULT_FANTASY_BOOK;
}

export function clampFantasyPropsState(state: OptimizerQueryState): OptimizerQueryState {
  const normalized = ensureFantasyBook(state.platform);

  if (normalized === state.platform && normalized === state.sportsbook) {
    return state;
  }

  return {
    ...state,
    sportsbook: normalized,
    platform: normalized,
  };
}

